import { AxiosRequestConfig } from 'axios';

const AxiosConfig: AxiosRequestConfig = {
  baseURL: process.env.REACT_APP_BASE_API_URL || '/api/',
  withCredentials: true,
  responseType: 'json',
  headers: {
    'Content-Type': 'application/json',
  },
};

export { AxiosConfig };
